export function ChatbotFooter() {
  return (
    <div className="rounded-b-lg text-xs font-semibold flex gap-2 px-3 py-1.5 justify-center items-center">
      <a
        className="inline-block py-1 px-3 hover:opacity-85"
        href="https://www.endion.ai"
        title="Chatbots para inmobiliarias con inteligencia artificial en WhatsApp y tu web"
        target="_blank"
      >
        <span className="inline-block px-2 text-gray-800 text-[12px]">Chatbot inmobiliario IA</span>
        <span className="inline-block py-1 px-3 rounded-lg bg-[#495aff] text-white cursor-pointer shadow-[0px_10px_20px_-10px_rgba(67,97,238,0.6)]">
          Endion
        </span>
      </a>
    </div>
  );
}
